const coach = {
    state: {
      addCoachDialog: {
        title: '新增教练信息',
        type: 'add'
      },
      coachSearch: {
          coachName:""
      },
      coachList:[],
      coachSearchBtnDisabled: true
    },
    getters: {
        addCoachDialog: state => state.addCoachDialog,
        coachSearch: state => state.coachSearch,
        coachSearchBtnDisabled: state => state.coachSearchBtnDisabled,
      coachList:state=>state.coachList
    },
    mutations: {
      SET_COACH_LIST:(state,payload)=>{
        state.coachList = payload;
        console.log(state.coachList);
      },
      SET_COACH_DIALOG_TITLE: (state, type) => {
        if (type === 'add') {
          state.addCoachDialog.title = '新增教练信息'
          state.addCoachDialog.type = 'add'
        } else {
          state.addCoachDialog.title = '编辑教练信息'
          state.addCoachDialog.type = 'edit'
        }
      },
      SET_COACH_SEARCH: (state, payload) => {
        state.coachSearch = payload;
      },
      SET_COACH_SEARCHBTN_DISABLED: (state, payload) => {
        state.coachSearchBtnDisabled = payload;
      }
    },
    actions: {
  
    }
  }
  
  export default coach